import * as React from "react";
import { observer } from "mobx-react";

// imported only for typings
// these are passed to the component from index.ts
import { BaseDict } from "./dict";
import { LiveSportsHamburgerBlockData } from "./data";

// external components
import { HamburgerNavigationItem } from "../../components"

/*
    Setup testing tools for MobX
    uncoment the <DevTools /> at the end of the LiveSportsHamburgerBlock component
*/
// import DevTools from "mobx-react-devtools";
// import { setLogEnabled, setUpdatesEnabled, setGraphEnabled } from "mobx-react-devtools";
// if (process.env.NODE_ENV === "development") {
//     setLogEnabled(true);
//     setUpdatesEnabled(true);
//     setGraphEnabled(true);
// }

@observer
export class LiveSportsHamburgerBlock extends React.Component<{
    dataProvider: LiveSportsHamburgerBlockData,
    dict: BaseDict,
    cms: any
}, {
    dataProvider: LiveSportsHamburgerBlockData
}> {
    dict: BaseDict;
    cms: any;

    constructor(props) {
        super(props);

        this.dict = this.props.dict;
        this.cms = this.props.cms;

        // setup data provider
        this.state = {
            dataProvider: this.props.dataProvider,
        }
    }

    /* istanbul ignore next */
    renderLiveSportsList() {
        return this.state.dataProvider.sportsData.map(
            (branchInfo, index) => {
                return this.renderHamburgerNavigationItem(branchInfo, index, true);
            }
        );
    }

    /* istanbul ignore next */
    renderCmsLinks() {
        return this.state.dataProvider.cmsLinks.map(
            (link, index) => {
                return this.renderHamburgerNavigationItem(link, index, false);
            }
        );
    }

    /* istanbul ignore next */
    renderHamburgerNavigationItem(object, index, isBranchItem) {
        let icon = isBranchItem ? { presetImage: `i-o-sport-alt-${object.id}`, cmsImage: undefined } : object.icon;

        return (
            <HamburgerNavigationItem
                key={isBranchItem ? "branch" + index : "link" + index}
                handler={object.handler}
                title={object.name || object.title}
                icon={icon}
                href={object.href}
                displayIcon={isBranchItem ? this.cms.ShowIconsForSports : undefined}
                count={object.totalLiveCount} />
        )
    }

    render() {
        return (
            <nav className="rj-hamburger-tabs-01-nav">
                {this.renderLiveSportsList()}
                {this.renderCmsLinks()}

                {/* {process.env.NODE_ENV === "development" && (
                    <DevTools />
                )} */}
            </nav>
        )
    }
}